import { UserLocationService } from 'src/app/@shared/services/user-location/user-location.service';
import { MapService } from './map.service';
import { take } from 'rxjs/operators';

// NOTE: Using global H from CDN 3.2 scripts loaded in index.html
declare const H: any;

export class MyLocationControl extends H.ui.Control {
  private container: HTMLElement;

  constructor(
    private readonly mapService: MapService,
    private readonly userLocationService: UserLocationService
  ) {
    // @ts-ignore protected constructor — correct call
    super();

    this.container = document.createElement('div');
    this.container.className = 'H_btn H_el my-location-control';
    this.container.title = 'Current Location';
    this.container.tabIndex = 0;

    this.container.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" class="H_icon" viewBox="0 0 24 24">
          <path d="M13 4V5V6.09375C15.5 6.53125 17.4688 8.5 17.9062 11H19H20V13H19H17.9062C17.4688 15.5312 15.5 17.5 13 17.9375V19V20H11V19V17.9375C8.46875 17.5 6.5 15.5312 6.0625 13H5H4V11H5H6.0625C6.5 8.5 8.46875 6.5312 11 6.09375V5V4H13ZM8 12C8 13.4375 8.75 14.75 10 15.4688C11.2188 16.1875 12.75 16.1875 14 15.4688C15.2188 14.75 16 13.4375 16 12C16 10.5938 15.2188 9.28125 14 8.5625C12.75 7.84375 11.2188 7.84375 10 8.5625C8.75 9.28125 8 10.5938 8 12ZM12 9.5C12.875 9.5 13.6875 10 14.1562 10.75C14.5938 11.5312 14.5938 12.5 14.1562 13.25C13.6875 14.0312 12.875 14.5 12 14.5C11.0938 14.5 10.2812 14.0312 9.8125 13.25C9.375 12.5 9.375 11.5312 9.8125 10.75C10.2812 10 11.0938 9.5 12 9.5Z"/>
      </svg>
    `;

    this.container.addEventListener('click', () => {
      this.onClick();
    });
  }

  /** Correct override (TS4114 fix) */
  public renderInternal(el: HTMLElement, doc: Document): void {
    el.appendChild(this.container);
  }

  /** Complete click handling logic */
  private onClick(): void {
    this.userLocationService
      .requestLocationPermissionForced()
      .pipe(take(1))
      .subscribe((granted) => {
        if (!granted) return;

        const loc = this.userLocationService.userLocation;
        if (!loc) return;

        const zoom = this.mapService.map.getZoom();

        this.mapService.updateMapLocation(
          { lat: loc.lat, lng: loc.lng },
          zoom,
          true
        );
      });
  }

  /** Signature must return Control → return this */
  public setAlignment(
    alignment: any
  ): any {
    // @ts-ignore (protected call)
    super.setAlignment(alignment);
    // @ts-ignore (type compatibility)
    return this;
  }
}
